import { useGetUserProfile } from '@leagueplatform/web-common';

const QUERY_CACHE_AND_STALE_TIME = 15 * 1000 * 60;

export const useGetHighmarkUserProfile = (): ReturnType<
  typeof useGetUserProfile
> =>
  useGetUserProfile({
    staleTime: QUERY_CACHE_AND_STALE_TIME,
    cacheTime: QUERY_CACHE_AND_STALE_TIME,
  });
